export default __webpack_public_path__ + "static/media/screen3.713c8c59.svg";